import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaCheck } from 'react-icons/fa';

const Pricing = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const pricingFeatures = [
    "Akses Eksklusif Webinar News Hack 2,5 Jam FULL",
    "GRATIS RE-SEAT! Ikuti Ulang Webinar Kapanpun",
    "Rekaman Webinar Seumur Hidup (Lifetime Access)",
    "Strategi Entry & Exit Presisi saat News High Impact",
    "Teknik Money Management Khusus News Trading",
    "LIVE PRAKTEK Pembuktian + Backtest",
    "1x Sesi Tanya Jawab Langsung dengan Mentor",
    "Bonus: E-Book 'Rahasia Scalping Ikigai' (Senilai 500rb)"
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 10, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        damping: 15,
        stiffness: 100
      }
    }
  };

  return (
    <section className="py-12 md:py-16 gradient-bg-reverse" id="pricing">
      <div className="container max-w-7xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.7 }}
          className="text-center mb-10"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-6">
            Dapatkan <span className="highlight">News Hack</span> Sekarang!
          </h2>
          
          <p className="text-center text-lg md:text-xl max-w-3xl mx-auto">
            Webinar eksklusif membahas strategi trading berita ekonomi yang telah terbukti menghasilkan profit 100-200 pips dalam sekali trading
          </p>
        </motion.div>
        
        <motion.div 
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mx-auto card-gradient border border-primary/20 rounded-2xl overflow-hidden shadow-2xl"
        >
          {/* Header */}
          <motion.div 
            initial={{ backgroundColor: "#c22a2a" }}
            animate={{ background: "linear-gradient(90deg, #c22a2a, #ff4d4d)" }}
            transition={{ duration: 1.5, repeat: Infinity, repeatType: "reverse" }}
            className="p-10 md:p-12 text-center"
          >
            <h3 className="text-3xl md:text-4xl font-bold mb-8">Webinar Eksklusif NEWS HACK</h3>
            <div className="mb-6">
              <div className="text-xl md:text-2xl line-through opacity-70 mb-3">Rp 350.000</div>
              <motion.div 
                initial={{ scale: 1 }}
                animate={{ scale: [1, 1.05, 1] }}
                transition={{ duration: 2, repeat: Infinity, repeatType: "reverse" }}
                className="text-5xl md:text-6xl font-bold highlight"
              >
                Rp 100.000
              </motion.div>
            </div>
            <div className="inline-block bg-black/20 px-6 py-3 rounded-lg text-base md:text-lg">
              🔥 DISKON 71%! ⏰ Terbatas 100 Orang Pertama
            </div>
          </motion.div>
          
          {/* Content */}
          <div className="p-8 md:p-10">
            <h4 className="highlight text-xl md:text-2xl font-semibold mb-6">Apa yang Anda Dapatkan:</h4>
            
            <motion.ul 
              variants={containerVariants}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
              className="space-y-4 mb-8"
            >
              {pricingFeatures.map((feature, index) => (
                <motion.li 
                  key={index}
                  variants={itemVariants}
                  className="flex items-start gap-3 pb-3 border-b border-white/10"
                >
                  <FaCheck className="text-green-500 flex-shrink-0 mt-1 text-lg" />
                  <span className="text-base md:text-lg">{feature}</span>
                </motion.li>
              ))}
            </motion.ul>
            
            <div className="text-center mb-6">
              <motion.a 
                whileHover={{ scale: 1.03, boxShadow: "0 10px 20px rgba(194, 42, 42, 0.4)" }}
                whileTap={{ scale: 0.97 }}
                href="/checkout" 
                className="btn-primary text-white font-bold py-4 px-6 rounded-xl text-lg md:text-xl block w-full"
              >
                AMANKAN KURSI SEKARANG
              </motion.a>
              <p className="text-sm md:text-base mt-3 text-red-400 font-semibold">⚠️ Kuota terbatas, sudah 67 orang mendaftar hari ini!</p>
            </div>
            
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
              transition={{ delay: 0.8, duration: 0.7 }}
              className="bg-black/20 rounded-xl p-5 flex flex-col sm:flex-row items-center gap-4"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-full flex items-center justify-center text-white flex-shrink-0 mb-2 sm:mb-0 shadow-lg">
                <span className="font-bold text-xl">ZOOM</span>
              </div>
              <div className="text-center sm:text-left">
                <h4 className="highlight font-semibold text-base md:text-lg mb-2">Via Zoom Meeting</h4>
                <p className="text-base md:text-lg text-textGray">
                  Webinar akan dilaksanakan pada 28 Mei 2025, pukul 19.00 - 21.30 WIB. Link akan dikirimkan 1 hari sebelum acara.
                </p>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Pricing;